import React, { useContext, useState, useEffect, useMemo } from 'react'
import MarginAnalysisContext from './../MarginAnalysisContext'
import { Grid, virtualizedGridRenderer } from '@integec/grid-tools'
import { rowHeaderRender } from 'core/utils'
import { OaMaScenarioHeaders } from './../Headers'
import { Modal, Button, message, Spin } from 'antd'
import MarginAnalysisUtilityUnitSelection from 'marginanalysis/MarginAnalysisUtilityUnitSelection'
import {
  getMarginAnalysisRecallRetrieveData,
  deleteMarginAnalysisScnerio,
} from 'api/pgads'
import { SpinContext, ErrorContext, JcTmpErrorContext } from 'context'
import {
  getUtilityNameMap,
  getUnitNameMap,
  getUnits,
  getApiTargetInfo,
  getClientInfo,
} from 'core'
import { connect } from 'react-redux'
import { isErrorContains } from 'core/component/JcTmpErrorDialog'
const ScenarioDialog = ({
  targetInfo,
  onCancelScenarioDialog,
  onClose,
  visible,
  unitNameMap,
  lostType = '1',
  // units,
  // ...props
}) => {
  const {
    scenarioList,
    setScenarioList,
    // selectedScenario,
    // setSelectedScenario,
    reloadScenario,
    // setWFRetrievedData,
    handleWFRetrieveData,
  } = useContext(MarginAnalysisContext)
  const { setTmpError } = useContext(JcTmpErrorContext)
  const { setSpinning, spinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const [unitChange, setUnitChange] = useState([])
  const [selectedRow, setSelectedRow] = useState([])
  const [data, setData] = useState([])

  useEffect(
    _ => {
      //       setSelectedDateRagePicker([moment('20190101'), moment('20190228')])
      reloadScenario(targetInfo)
    },
    [setError, targetInfo, setScenarioList, reloadScenario]
  )

  useEffect(
    _ => {
      if (unitChange[1]) {
        const data = scenarioList.filter(
          s =>
            s.utility + s.unit === unitChange[1] ||
            s.utility + s.unitid === unitChange[1]
        )
        setData(data)
      } else setData(scenarioList)
    },
    [scenarioList, unitChange]
  )

  const showDeleteConfirm = _ => {
    if (selectedRow.length <= 0) {
      message.warn('Please, Seleact scenario')
      return
    }
    Modal.confirm({
      title: 'Do you want to Delete selected scenario?',
      // content: 'Delete Scenario',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      confirmLoading: spinning,
      onOk() {
        setSpinning(true)
        deleteMarginAnalysisScnerio(targetInfo)(selectedRow[0].scenarioId).fork(
          setError,
          _ => {
            setSpinning(false)
            message.info('Scenario Deleted')
            reloadScenario(targetInfo)
          }
        )
      },
      onCancel() {},
    })
  }

  const reCallDataRetrieve = _ => {
    if (selectedRow.length <= 0) {
      message.error('Please,Select record for Scenario')
      return
    }
    const reqData = {
      mode: 'WHATIF',
      startDate: selectedRow[0].startdate, // .format('YYYY-MM-DD'),
      endDate: selectedRow[0].enddate, // .format('YYYY-MM-DD'),
      utility: selectedRow[0].utility,
      unit: selectedRow[0].unit,
      emktId: selectedRow[0].unitid,
      scenario: selectedRow[0],
      showCauseCode: false,
      lostType,
    }

    setSpinning(true)
    getMarginAnalysisRecallRetrieveData(targetInfo)(reqData).fork(
      error => {
        setError(error)
      },
      data => {
        setSpinning(false)
        if (!isErrorContains(data.errors)) {
          handleWFRetrieveData(data)
          onClose(selectedRow[0])
        } else {
          setTmpError(data.errors)
        }
      }
    )
  }
  const height = 300
  const width = 1250

  const headerWithFormatter = useMemo(
    _ =>
      OaMaScenarioHeaders.map(h =>
        h.ident === 'unit'
          ? {
              ...h,
              choices: [],
              // dataGetter: generateDataGetter,
              dataFormatter: ({ value, rowData }) =>
                unitNameMap[rowData.utility + '' + value] ||
                rowData.utility + '' + value,
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.utility + '' + rowData.unit] ||
                rowData.utility + '' + rowData.unit,
            }
          : h
      ),
    [unitNameMap]
  )

  return (
    <Modal
      maskClosable={false}
      destroyOnClose
      title="Recall Scenario"
      onCancel={onCancelScenarioDialog}
      width={width}
      height={height}
      visible={visible}
      footer={
        <div>
          <Button
            loading={spinning}
            disabled={selectedRow.length <= 0}
            onClick={reCallDataRetrieve}
            type="primary"
          >
            Recall Scenario
          </Button>
          <Button loading={spinning} onClick={onCancelScenarioDialog}>
            Cancel
          </Button>
          <Button
            loading={spinning}
            disabled={selectedRow.length <= 0}
            onClick={showDeleteConfirm}
            type="danger"
          >
            Delete Scenario
          </Button>
        </div>
      }
    >
      <Spin spinning={spinning}>
        <div
          style={{
            height,
            gridRowGap: '10px',
            display: 'grid',
            // gridTemplateRows: '50px auto',
            alignContent: 'flex-start',
          }}
        >
          <MarginAnalysisUtilityUnitSelection
            onUnitChange={setUnitChange}
            utility={unitChange[0]}
            unit={unitChange[1]}
          />
          <Grid
            // ref={this.GridRef}
            // editMode="cell"
            data={data || []}
            headers={headerWithFormatter}
            altBgColor="#ebebeb"
            render={virtualizedGridRenderer({
              // autoFixColByKey,
              rowHeaderRender,
              height: height - 20,
              width: width - 100,
              headerRowHeight: 30,
            })}
            onSelectionChange={sel => {
              const { selectedRows } = sel

              setSelectedRow(selectedRows)
              // onClose(selectedRows[0])
            }}
            initialSortOptions={headerWithFormatter}
            sortOptions={headerWithFormatter}
            sortEnabled
            // isEditable={isEditable}
            selectionType="row"
            selectionMode="single"
          />
        </div>
      </Spin>
    </Modal>
  )
}

const mapStateToProps = state => ({
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  units: getUnits(state),
  targetInfo: getApiTargetInfo(state),
  CLIENT: getClientInfo(state),
})
export default connect(mapStateToProps)(ScenarioDialog)
